export class Tag {
    display: String;
    value : String;
}


// WEBPACK FOOTER //
// ./src/app/entities/tag.ts